
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Aus eigener Erfahrung weiss man, dass in einer langjährigen Beziehungen der Körperkontakt weniger wird.
Genauso wie der Sex. Dass diese Tendenz aber nicht nur bei älteren, langjährigen Paaren festgestellt werden kann,
sondern auch bei jungen Leuten, hat der deutsche Psychologe Michael Schredl festgestellt. Gemeinsam mit seinem Team
analysierte er verschiedene Studienergebnisse und kam zu einem doch etwas überraschenden Ergebnis: Selbst junge
Studentenpaare lösten sich im Bett flott voneinander. Während einer Beziehungsdauer von zwei Jahren schliefen
die frisch Verliebten zuerst ineinander «verknotet», gingen im weiteren Verlauf der Beziehung zur Löffelchenstellung
über, und verzichteten später sogar auf Körperkontakt. Die «beste» Vorbereitung auf die weitere Entwicklung.
Denn: Rund ein Drittel der  über 60-Jährigen schläft in getrennten Zimmern. Bei den 70-Jährigen sind es die Hälfte der Paare.`}</p>
    <small><Link href="https://journals.ub.uni-heidelberg.de/index.php/IJoDR/article/view/32590/pdf" mdxType="Link">Uni Heidelberg</Link></small>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;